module.exports = __webpack_public_path__ + "img/inspiring_background_parallax.8ba7b7b.webp";